<template>
    <div>
        <Head :title="__(title)" />
        <div class="main flex-1 flex flex-col sec_chat">

            <div class="flex-1 flex h-full gap-5">
                <div class="sidebar h-full hidden lg:flex w-1/3 flex-2 flex-col bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                    <div class="chat-box h-full flex flex-col">
                        <div class="chat-left-aside h-full flex flex-col">
                            <div class="c-top p-6 border-b border-gray-50 bg-gray-50/50">
                                <div class="media mb-4 flex items-center gap-3">
                                    <img v-if="user.photo" :src="user.photo" alt="" class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm">
                                    <img v-else src="/images/svg/profile.svg" alt="" class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm">
                                    <div class="about">
                                        <div class="name font-bold text-gray-800">{{ user.first_name }} {{ user.last_name }}</div>
                                        <div class="status text-xs font-medium uppercase tracking-wider" :class="activeType === 'internal' ? 'text-indigo-500' : 'text-blue-500'">{{ __(user.role.name) }}</div>
                                    </div>
                                </div>
                                
                                <div class="search relative">
                                    <search-input v-model="form.search" class="w-full" @reset="reset"></search-input>
                                </div>
                            </div>
                            
                            <div class="c-list flex-1 overflow-y-auto">
                                <!-- User Directory for Internal Chat -->
                                <div v-if="false" class="px-5 py-4"></div>

                                <!-- Conversation List -->
                                <div class="py-2">
                                    <Link v-for="conversation in conversations.data" :key="conversation.id" :href="route('chat.current', {id: conversation.id, type: activeType})"
                                         class="entry group mx-4 mb-2 p-3 flex items-center gap-3 rounded-xl transition-all duration-200"
                                         :class="chat && (conversation.id === chat.id) ? (activeType === 'internal' ? 'bg-indigo-50 border border-indigo-100' : 'bg-blue-50 border border-blue-100') : 'hover:bg-gray-50 border border-transparent'">
                                        
                                        <div class="relative flex-shrink-0">
                                            <div v-if="conversation.creator && conversation.creator.photo" class="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-sm">
                                                <img :src="conversation.creator.photo" class="w-full h-full object-cover">
                                            </div>
                                            <div v-else class="w-12 h-12 rounded-full flex items-center justify-center font-bold text-white shadow-sm"
                                                 :class="activeType === 'internal' ? 'bg-gradient-to-br from-indigo-500 to-purple-600' : 'bg-gradient-to-br from-blue-500 to-cyan-600'">
                                                {{ conversation.creator ? Array.from(conversation.creator.first_name || conversation.creator.name)[0] : '?' }}
                                            </div>
                                            <div v-if="conversation.total_entry" class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 border-2 border-white rounded-full flex items-center justify-center">
                                                <span class="text-[10px] text-white font-bold">{{ conversation.total_entry }}</span>
                                            </div>
                                        </div>

                                        <div class="flex-1 min-w-0">
                                            <div class="flex justify-between items-start">
                                                <h4 class="text-sm font-bold text-gray-800 truncate" :class="{'text-indigo-700': activeType === 'internal' && chat && conversation.id === chat.id, 'text-blue-700': activeType === 'support' && chat && conversation.id === chat.id}">
                                                    {{ conversation.creator ? (conversation.creator.full_name || conversation.creator.name) : 'Unknown' }}
                                                </h4>
                                                <span class="text-[10px] text-gray-400 font-medium">{{ moment(conversation.updated_at).format('HH:mm') }}</span>
                                            </div>
                                            <p class="text-xs text-gray-500 truncate mt-0.5 leading-relaxed">{{ conversation.title || __('No messages yet') }}</p>
                                        </div>
                                    </Link>
                                    <div v-if="!conversations.data.length" class="flex flex-col items-center justify-center py-12 px-6 text-center opacity-50">
                                        <icon :name="activeType === 'internal' ? 'users' : 'chat'" class="w-10 h-10 mb-3 text-gray-300" />
                                        <p class="text-sm text-gray-500 leading-relaxed">{{ activeType === 'internal' ? __('No team chats yet. Pick a staff member below!') : __('No conversations found. Start a new one above!') }}</p>
                                    </div>

                                    <!-- Vertical Staff Directory (Internal Only) -->
                                    <div v-if="activeType === 'internal' && !form.search" class="mt-4 pb-8 border-t border-gray-50 bg-gray-50/20">
                                        <div class="px-7 py-3 mb-2 flex items-center justify-between sticky top-0 bg-gray-50/80 backdrop-blur-sm z-10 border-b border-gray-100/50">
                                           <h3 class="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">{{ __('Team Members') }}</h3>
                                           <icon name="users" class="w-3 h-3 text-indigo-300" />
                                        </div>
                                        <div class="px-4 space-y-1">
                                            <div v-for="staff in internalUsers" :key="staff.id" @click="startInternalChat(staff.id)"
                                                 class="flex items-center gap-4 p-3 rounded-xl cursor-pointer hover:bg-white shadow-none hover:shadow-sm transition-all border border-transparent hover:border-indigo-100/30 group">
                                                <div class="relative">
                                                    <div v-if="staff.photo" class="w-10 h-10 rounded-full overflow-hidden border border-white shadow-sm">
                                                        <img :src="staff.photo" class="w-full h-full object-cover">
                                                    </div>
                                                    <div v-else class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-xs uppercase shadow-sm">
                                                        {{ Array.from(staff.name)[0] }}
                                                    </div>
                                                    <div class="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></div>
                                                </div>
                                                <div class="flex-1 min-w-0">
                                                    <div class="text-sm font-bold text-gray-700 group-hover:text-indigo-700 truncate capitalize">{{ staff.name }}</div>
                                                    <div class="text-[10px] text-gray-400 truncate">{{ staff.email }}</div>
                                                </div>
                                                <icon name="cheveron-right" class="w-4 h-4 text-gray-300 group-hover:text-indigo-400 group-hover:translate-x-0.5 transition-all" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Chat Area -->
                <div class="chat-area h-full flex-1 flex flex-col bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden relative">
                    <div v-if="chat" class="flex flex-col h-full">
                        <!-- Chat Header -->
                        <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between transition-all duration-300 backdrop-blur-md sticky top-0 z-10"
                             :class="activeType === 'internal' ? 'bg-indigo-50/80' : 'bg-blue-50/80'">
                            <div class="flex items-center gap-4">
                                <div class="relative">
                                    <div v-if="chat.creator && chat.creator.photo" class="w-11 h-11 rounded-full overflow-hidden border-2 border-white shadow-sm">
                                        <img :src="chat.creator.photo" class="w-full h-full object-cover">
                                    </div>
                                    <div v-else class="w-11 h-11 rounded-full flex items-center justify-center font-bold text-white shadow-sm"
                                         :class="activeType === 'internal' ? 'bg-gradient-to-br from-indigo-500 to-purple-600' : 'bg-gradient-to-br from-blue-500 to-cyan-600'">
                                        {{ chat.creator ? Array.from(chat.creator.first_name || chat.creator.name)[0] : '?' }}
                                    </div>
                                    <div class="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full shadow-sm"></div>
                                </div>
                                <div>
                                    <h3 class="text-base font-bold text-gray-800 leading-none mb-1">{{ chat.creator ? (chat.creator.full_name || chat.creator.name) : 'Unknown' }}</h3>
                                    <span class="text-xs text-gray-400 font-medium">{{ chat.creator ? (chat.creator.email) : '' }}</span>
                                </div>
                            </div>
                            <div class="flex items-center gap-2">
                                <button v-if="user_access.chat.delete" @click="destroy(chat.id)" class="w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all">
                                    <icon name="trash" class="w-5 h-5" />
                                </button>
                            </div>
                        </div>

                        <!-- Messages -->
                        <div class="messages flex-1 overflow-y-auto p-6 space-y-4" :class="activeType === 'internal' ? 'bg-indigo-50/20' : 'bg-blue-50/20'" ref="messageContainer">
                            <div v-for="(message, index) in chat.messages" :key="index" 
                                 class="flex flex-col w-full"
                                 :class="message.user_id === user.id ? 'items-end' : 'items-start'">
                                
                                <div class="flex max-w-[80%] gap-2" :class="message.user_id === user.id ? 'flex-row-reverse' : 'flex-row'">
                                    <!-- Avatar for others -->
                                    <div v-if="message.user_id !== user.id" class="flex-shrink-0 mt-auto">
                                        <div v-if="message.user && message.user.photo" class="w-8 h-8 rounded-full overflow-hidden mb-1 shadow-sm border border-white">
                                            <img :src="message.user.photo" class="w-full h-full object-cover">
                                        </div>
                                        <div v-else-if="message.contact && message.contact.photo" class="w-8 h-8 rounded-full overflow-hidden mb-1 shadow-sm border border-white">
                                          <img :src="message.contact.photo" class="w-full h-full object-cover">
                                        </div>
                                        <div v-else class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-[10px] font-bold text-gray-500 mb-1 border border-white shadow-sm">
                                            {{ message.user ? Array.from(message.user.first_name)[0] : (message.contact ? Array.from(message.contact.first_name)[0] : '?') }}
                                        </div>
                                    </div>

                                    <div class="flex flex-col" :class="message.user_id === user.id ? 'items-end' : 'items-start'">
                                        <!-- Name for internal group-like view (optional but nice) -->
                                        <span v-if="activeType === 'internal' && message.user_id !== user.id" class="text-[10px] font-bold text-gray-400 ml-1 mb-1">
                                            {{ message.user ? message.user.full_name : 'Team member' }}
                                        </span>

                                        <div class="px-4 py-3 rounded-2xl shadow-sm relative group transition-all duration-200"
                                             :class="message.user_id === user.id 
                                                ? (activeType === 'internal' ? 'bg-indigo-600 text-white rounded-tr-none' : 'bg-blue-600 text-white rounded-tr-none') 
                                                : 'bg-white text-gray-800 rounded-tl-none border border-gray-100'">
                                            <p class="text-sm leading-relaxed whitespace-pre-wrap">{{ message.message }}</p>
                                        </div>
                                        <span class="text-[9px] font-bold text-gray-400 uppercase tracking-tighter mt-1 mx-1">
                                            {{ moment(message.created_at).format('h:mm A') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Typing Bar -->
                        <div class="p-6 bg-white border-t border-gray-100 relative z-20">
                            <div class="flex items-center gap-3 bg-gray-50 p-2 pl-4 rounded-2xl border border-gray-100 shadow-inner transition-all duration-300"
                                 :class="activeType === 'internal' ? 'focus-within:border-indigo-400' : 'focus-within:border-blue-400'">
                                <textarea v-model="message" 
                                          @keydown.enter.exact.prevent="sendMessage" 
                                          class="flex-1 bg-transparent border-none focus:ring-0 text-sm py-2 resize-none max-h-32 leading-relaxed" 
                                          rows="1" 
                                          :placeholder="__('Type a message...')"
                                          ref="inputArea"></textarea>
                                
                                <button @click="sendMessage" 
                                        :disabled="!message"
                                        :class="activeType === 'internal' ? 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-100' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-100'"
                                        class="w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-lg transition-all transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed">
                                    <icon name="send" class="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Welcome View -->
                    <div v-else class="flex flex-col items-center justify-center h-full p-12 text-center bg-gray-50/50">
                        <div class="relative mb-8">
                            <div class="w-32 h-32 bg-white rounded-full shadow-2xl flex items-center justify-center border border-gray-50 relative z-10 transition-transform duration-700 hover:rotate-6">
                                <icon :name="activeType === 'internal' ? 'users' : 'chat'" 
                                      class="w-16 h-16" 
                                      :class="activeType === 'internal' ? 'text-indigo-400' : 'text-blue-400'" />
                            </div>
                            <div class="absolute -top-4 -right-4 w-12 h-12 bg-yellow-400 rounded-2xl shadow-lg border-4 border-white animate-bounce flex items-center justify-center">
                                <span class="text-xl">{{ activeType === 'internal' ? '🏢' : '👋' }}</span>
                            </div>
                        </div>
                        <h2 class="text-2xl font-black text-gray-800 mb-3 tracking-tight">
                            {{ activeType === 'internal' ? __('Internal Team Hub') : __('Customer Support Hub') }}
                        </h2>
                        <p class="text-gray-500 max-w-sm mb-8 leading-relaxed font-medium">
                            {{ activeType === 'internal' 
                                ? __('Stay connected with your team members in strict private isolation.') 
                                : __('Manage customer inquiries professionally and maintain high quality support.') 
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head } from '@inertiajs/inertia-vue3'
import moment from 'moment'

export default {
    metaInfo: { title: 'Chat' },
    components: {
        SearchInput,
        Icon, Pagination, Link, Head
    },
    layout: Layout,
    props: {
        filters: Object,
        type: String, // Pass through from backend
        conversations: Object,
        chat: Object,
        title: String
    },
    remember: 'form',
    data() {
        return {
            message: null,
            activeType: this.type || 'support',
            internalUsers: [],
            user: this.$page.props.auth.user,
            user_access: this.$page.props.auth.user.access,
            form: {
                search: this.filters.search,
                type: this.type || 'support',
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route(this.activeType === 'internal' ? 'chat.internal' : 'chat.support'), pickBy(this.form), { 
                    preserveState: true,
                    preserveScroll: true
                })
            }, 150),
        },
        chat: {
            deep: true,
            handler() {
                this.scrollToBottom();
            }
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
            this.form.type = this.activeType
        },
        switchType(type) {
            this.activeType = type
            this.form.type = type
            if (type === 'internal' && this.internalUsers.length === 0) {
                this.fetchInternalUsers();
            }
        },
        fetchInternalUsers() {
            this.axios.get(this.route('chat.users')).then(response => {
                this.internalUsers = response.data;
            });
        },
        startInternalChat(userId) {
            this.$inertia.get(this.route('chat.start', userId));
        },
        sendMessage(){
            if (!this.message || !this.message.trim()) return;
            
            const messageData = {
                message: this.message,
                _token: this.$page.props.csrf_token,
                conversation_id: this.chat.id
            }
            this.message = ''
            
            this.axios.post(this.route('chat.message'), messageData).then((response) => {
                if(response.data){
                    // Only append if not already appended by Echo
                    const exists = this.chat.messages.some(m => m.id === response.data.id);
                    if (!exists) {
                        this.chat.messages.push(response.data)
                    }
                }
                this.scrollToBottom();
            }).catch((error) => {
                console.log(error)
            })
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.messageContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        destroy(id) {
            if (confirm('Are you sure you want to delete this conversation?')) {
                this.$inertia.delete(this.route('chat.destroy', id), {
                    data: { type: this.activeType }
                })
            }
        },
        pushMessage(message){
            let chatItem = this.conversations.data.find(x => x.id === message.conversation_id)
            if(typeof chatItem === 'object' ){
                chatItem.title = message.message
                
                if(!!this.chat && (this.chat.id === message.conversation_id)){
                    const exists = this.chat.messages.some(m => m.id === message.id);
                    if (!exists) {
                        this.chat.messages.push(message)
                        this.scrollToBottom();
                    }
                    chatItem.total_entry = 0
                } else {
                    chatItem.total_entry = (chatItem.total_entry || 0) + 1
                }
            } else if (message.user_id !== this.user.id) {
                // Fetch conversations again to show the new interaction
                this.$inertia.reload({ only: ['conversations'] });
            }
        }
    },
    mounted() {
        this.scrollToBottom();
        if (this.activeType === 'internal') {
            this.fetchInternalUsers();
        }
    },
    created(){
        this.moment = moment
        let that = this
        window.Echo.private('messages').listen('NewChatMessage', function (e){
            console.log('Echo NewChatMessage', e);
            if(typeof e.chatMessage === 'object'){
                that.pushMessage(e.chatMessage)
            }
        })
    },
}
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
